module.exports = __webpack_public_path__ + "static/media/logo.c735c857.png";